import storageService from '../services/storageService';

export const authHeader = () => {
  return {
    common: {
      AuthApi: `Bearer ${storageService.getToken()}`,
    },
  };
};
